// export DsfShortcutMenu from "./shortcutMenu.vue";
export const DsfShortcutMenu = dsf.defineAsyncComponent("DsfShortcutMenu", () => import(/*webpackChunkName:"platform_homepage"*/ "./shortcutMenu.vue"));
